import React from 'react';

const NextImage = (props: any) => {
  const { src, className, height, width, style, onClick, alt } = props;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      height={height}
      width={width}
      style={style}
      onClick={onClick}
    />
  );
};

export default NextImage;
